import request from '@/sheep/request';

export interface User {
	avatar : string
	nickname : string
	sex ?: number
	birthday : string
	areaId ?: number
	region ?: string
	intro ?: string
}

// 获得基本信息
export const getUserInfo = async () => {
	return request({
		url: '/member/user/get',
		method: 'GET',
		custom: {
			showLoading: false,
			auth: true,
		},
	});
}
// 修改基本信息
export const updateUser = async (data) => {
	return request({
		url: '/member/user/update',
		method: 'PUT',
		data,
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '更新成功'
		},
	});
}
// 修改用户手机
export const updateUserMobile = async (data) => {
	return request({
		url: '/member/user/update-mobile',
		method: 'PUT',
		data,
		custom: {
			loadingMsg: '验证中',
			showSuccess: true,
			successMsg: '修改成功'
		},
	});
}
// 基于微信小程序的授权码，修改用户手机
export const updateUserMobileByWeixin = async (code) => {
	return request({
		url: '/member/user/update-mobile-by-weixin',
		method: 'PUT',
		data: {
			code
		},
		custom: {
			showSuccess: true,
			loadingMsg: '获取中',
			successMsg: '修改成功'
		},
	});
}
// 修改密码
export const updateUserPassword = async (data) => {
	return request({
		url: '/member/user/update-password',
		method: 'PUT',
		data,
		custom: {
			loadingMsg: '验证中',
			showSuccess: true,
			successMsg: '修改成功'
		},
	});
}
export const updateUserPasswordByPassword = async (data) => {
	return request({
		url: '/member/user/update-password-by-password',
		method: 'PUT',
		data,
		custom: {
			loadingMsg: '验证中',
			showSuccess: true,
			successMsg: '修改成功'
		},
	});
}

// 重置密码
export const resetUserPassword = async (data) => {
	return request({
		url: '/member/user/reset-password',
		method: 'PUT',
		data,
		custom: {
			loadingMsg: '验证中',
			showSuccess: true,
			successMsg: '修改成功'
		}
	});
}

export const writeOff = async () => {
	return request({
		url: '/member/user/write-off',
		method: 'GET'
	});
}

